import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TableDocument from "../../TableDocument";
import { api, get } from "../../../../utils/api";
import FilterModal from "../../../../Components/Common/FilterModal";
import TopMenu from "../../TopMenu";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import ApprovalSidebar from "../../../../Layout/ApporvalSidebar";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import RailViewPage from "../../RailView";
import AirViewPage from "../../AirView";
import ShipeViewPage from "../../ShipView";
import RoadViewPage from "../../RoadView";

const TransportationDocuments = () => {
  const { user } = useUser();
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("Road Transportation");
  const [url, setUrl] = useState("road");
  const [approvalUrl, setApprovalUrl] = useState(
    "/scope3/roadTransportation/apporveOrReject"
  );
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [roadFilter, setRoadFilter] = useState({
    origin: "",
    destination: "",
  });
  const [railFilter, setRailFilter] = useState({
    origin: "",
    destination: "",
  });
  const [airFilter, setAirFilter] = useState({
    origin: "",
    destination: "",
  });
  const [shipFilter, setShipFilter] = useState({
    origin: "",
    destination: "",
  });

  const fetchData = async (filters = isFiltersApplied ? filterObj : {}) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        facilityList: selectedFacility.join(","),
        page,
        limit: 10,
        search: searchQuery,
      }).toString();
      let apiurl =
        url === "air"
          ? `${api}/scope3/airTransportation/apporevelist?${queryParams}`
          : url === "rail"
          ? `${api}/scope3/railTransportation/apporevelist?${queryParams}`
          : url === "water"
          ? `${api}/scope3/shipTransportation/apporevelist?${queryParams}`
          : `${api}/scope3/roadTransportation/apporevelist?${queryParams}`;
      const response = await get(apiurl);
      setData(response.data.data);
      setPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, filterObj, searchQuery, fromDate, toDate, selectedFacility]);

  const heading = [
    {
      title: "Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,

    {
      title: "Assosiated Vendor",
      key: "associatedVendor",
      field: "logisticVendorLegalName",
    },
    {
      title: "Driver",
      key: "driver",
      field: "driverName",
    },
    {
      title: "Source",
      key: "source",
    },
    {
      title: "Destination",
      key: "destination",
    },
    // {
    //   title: "Vehicle",
    //   key: "vehicle",
    //   field: "vehicleNumber",
    // },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const railHeading = [
    {
      title: "Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Origin",
      key: "origin",
    },
    {
      title: "Destination",
      key: "destination",
    },
    {
      title: "Freight Load (tonnes)",
      key: "freightLoad",
      field: "value",
    },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const waterHeading = [
    {
      title: "Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Origin",
      key: "origin",
    },
    {
      title: "Destination",
      key: "destination",
    },
    {
      title: "Shipment Category",
      key: "categoryOfShipment",
    },
    // {
    //   title: "Shipment Type",
    //   key: "typeOfShipment",
    // },
    // {
    //   title: "Freight Load (tonnes)",
    //   key: "freightLoad.value",
    // },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const waterView = [
    { key: "consumptionPeriod", title: "Consumption Period" },
    { key: "origin", title: "Origin" },
    { key: "categoryOfShipment", title: "Category of Shipment" },
    { key: "typeOfShipment", title: "Type of Shipment" },
    { key: "freightLoad", title: "Freight Load" },
    { key: "distanceCovered", title: "Distance Covered" },
    { key: "transportationType", title: "Tranporation Type" },
    // { key: "transportationDate", title: "Transportation Date" },
    { key: "destination", title: "Destination" },
    { key: "remark", title: "Remarks" },
  ];
  const roadView = [
    // { key: "tripId", title: "Trip ID" },
    { key: "tripDate", title: "Trip Date" },
    { key: "associatedVendorName", title: "Vendor Name" },
    { key: "driverName", title: "Driver Name" },
    { key: "vehicleName", title: "Vehicle" },
    // { key: "distanceTravel", title: "Distance Travelled" },
    // { key: "startTime", title: "Start Time" },
    // { key: "endTime", title: "End Time" },
    { key: "source", title: "Source Location" },
    { key: "destination", title: "Destination Location" },
    // { key: "vehicle", title: "Vehicle Used" },
    // { key: "declaredEfficiency", title: "Declared Efficiency" },
  ];
  const railView = [
    { key: "consumptionPeriod", title: "Consumption Period" },
    // { key: "facility", title: "Facility" },
    { key: "transportationType", title: "Tranporation Type" },

    { key: "origin", title: "Origin" },
    { key: "destination", title: "Destination" },
    { key: "freightLoad", title: "Freight Load" },
    { key: "distanceCovered", title: "Distance Covered" },
    { key: "remarks", title: "Remarks" },
  ];
  const airView = [
    { key: "consumptionPeriod", title: "Consumption Period" },
    { key: "transportationType", title: "Tranporation Type" },

    { key: "freightLoad", title: "Freight Load" },
    { key: "distanceCovered", title: "Distance Covered" },
    { key: "origin", title: "Origin" },
    { key: "destination", title: "Destination" },

    { key: "remark", title: "Remarks" },
  ];
  const fetchDataCallback = async () => {
    await fetchData();
  };

  const fetchFilterData = async (endpoint) => {
    return get(endpoint)
      .then((res) => {
        console.log(res?.data);
        return {
          origin: res?.data?.data?.origin,
          destination: res?.data?.data?.destination,
        };
      })
      .catch((err) => {
        console.log(err);
        return { origin: [], destination: [] };
      });
  };

  useEffect(() => {
    Promise.all([
      fetchFilterData("/scope3/roadTransportation/road/filter"),
      fetchFilterData("/scope3/railTransportation/rail/filter"),
      fetchFilterData("/scope3/airTransportation/air/filter"),
      fetchFilterData("/scope3/shipTransportation/ship/filter"),
    ]).then(([roadData, railData, airData, shipData]) => {
      setRoadFilter(roadData);
      setRailFilter(railData);
      setAirFilter(airData);
      setShipFilter(shipData);
    });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filterDataRail = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Source",
      type: "option",
      key: "origin",
      value: railFilter.origin ? railFilter.origin : [],
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: railFilter.destination ? railFilter.destination : [],
    },
    {
      title: "Freight Load (tonnes)",
      type: "limit",
      key: "load",
      value: ["one", "two"],
    },
  ];

  const filterDataRoad = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Source",
      type: "option",
      key: "origin",
      value: roadFilter?.origin ? roadFilter.origin : [],
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: roadFilter?.destination ? roadFilter.destination : [],
    },
  ];

  const filterDataShip = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Origin",
      type: "option",
      key: "origin",
      value: shipFilter?.origin ? shipFilter.origin : [],
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: shipFilter?.destination ? shipFilter.destination : [],
    },
    // {
    //   title: "Shipment Category",
    //   type: "option",
    //   key: "categoryOfShipment",
    //   value: ["filterDestination"],
    // },
    // {
    //   title: "Shipment Type",
    //   type: "option",
    //   key: "typeOfShipment",
    //   value: ["filterDestination"],
    // },
    {
      title: "Freight Load (tonnes)",
      type: "limit",
      key: "load",
      value: ["one", "two"],
    },
  ];

  const filterDataAir = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Origin",
      type: "option",
      key: "origin",
      value: airFilter?.origin ? airFilter.origin : [],
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: airFilter?.destination ? airFilter.destination : [],
    },
    {
      title: "Freight Load (tonnes)",
      type: "limit",
      key: "load",
      value: ["one", "two"],
    },
  ];

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setIsFiltersApplied(true);
    console.log("Applied Filters:", newFilterObj);
  };

  console.log("filto", filterObj);

  useEffect(() => {
    setFilterObj({});
    setIsFiltersApplied(false);
  }, [url]);

  const handleToggle = (option, url, approvalUrl) => {
    setSelectedOption(option);
    setUrl(url);
    setApprovalUrl(approvalUrl);
  };

  const toggleData = [
    {
      title: "Road Transportation",
      url: "road",
      approvalUrl: "/scope3/roadTransportation/apporveOrReject",
    },
    {
      title: "Rail Transportation",
      url: "rail",
      approvalUrl: "/scope3/railTransportation/apporveOrReject",
    },
    {
      title: "Air Transportation",
      url: "air",
      approvalUrl: "/scope3/airTransportation/apporveOrReject",
    },
    {
      title: "Water Transportation",
      url: "water",
      approvalUrl: "/scope3/shipTransportation/apporveOrReject",
    },
  ];

  return (
    <MainDashboardLayout sidebar={<ApprovalSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <TopMenu
        {...{
          setDrawerFilterOpen: setIsFilterModalOpen,
          selectedMonth,
          setSelectedMonth,
          selectedYear,
          setSelectedYear,
          selectedOption,
          handleToggle,
          filterApplied: isFiltersApplied,
          toggleData,
          setSearchQuery,
          fromDate,
          setFromDate,
          toDate,
          setToDate,
          selectedFacility,
          setSelectedFacility,
          width: "9rem",
        }}
        heading={"Transportation and Distribution"}
      />
      <TableDocument
        data={data}
        documnets={["Apporval"]}
        totalPages={totalPages}
        page={page}
        handleChangePage={handleChangePage}
        headers={
          selectedOption === "Rail Transportation" ||
          selectedOption === "Air Transportation"
            ? railHeading
            : selectedOption === "Water Transportation"
            ? waterHeading
            : selectedOption === "Road Transportation"
            ? heading
            : null
        }
        columnWidth={
          selectedOption === "Rail Transportation" ||
          selectedOption === "Air Transportation"
            ? user?.companyAdmin
              ? "12% 15% 14% 14% 15% 15% 9%"
              : // : "12% 22% 16% 17% 20% 9%"
                "12% 13% 12% 14% 13% 12% 12% 9%"
            : user?.companyAdmin
            ? "12% 12% 13% 10% 10% 10% 10% 12% 9%"
            : "12% 13% 12% 14% 13% 12% 12% 9%"
        }
        setsnackOpen={setsnackOpen}
        fetchDataCallback={fetchDataCallback}
        apiUrl={approvalUrl}
        // viewcolumnWidth={viewcolumnWidth}
        viewheaders={
          selectedOption === "Rail Transportation"
            ? railView
            : selectedOption === "Air Transportation"
            ? airView
            : selectedOption === "Water Transportation"
            ? waterView
            : selectedOption === "Road Transportation"
            ? roadView
            : ""
        }
        viewPage={
          selectedOption === "Rail Transportation"
            ? RailViewPage
            : selectedOption === "Air Transportation"
            ? AirViewPage
            : selectedOption === "Water Transportation"
            ? ShipeViewPage
            : selectedOption === "Road Transportation"
            ? RoadViewPage
            : ""
        }
      />
      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={
          url === "rail"
            ? filterDataRail
            : url === "road"
            ? filterDataRoad
            : url === "water"
            ? filterDataShip
            : url === "air"
            ? filterDataAir
            : null
        }
        onFilterChange={handleFilterChange}
        title="Filter"
      />
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default TransportationDocuments;
